<template>
  <div id="banner-logo">
    <img class="logo" src="~@imagesBrand/logo.svg" :alt="brandName">
  </div>
</template>

<script>
export default {
  props: {
    brandName: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
  #banner-logo {
    height: 2.75rem;
    img {
      height: 2.75rem;
      padding: 0.25rem 0;
    }
  }
</style>
